import { TbMessage } from 'react-icons/tb';
import Logo from '../../layout/Navbar/Logo';
import MainPopupMenu from '../../layout/Navbar/MainPopupMenu';

const MenuHeader = () => (
  <span className="flex size-full h-[64px] max-h-[64px] flex-row items-center justify-between gap-2 border-b border-solid border-slate-300 px-2">
    <span className="line-clamp-1 flex h-full grow flex-col items-start justify-center overflow-hidden text-ellipsis break-all font-bold text-slate-500">
      <Logo size={22} showText />
    </span>
    <span className="hidden h-full flex-col items-center justify-center p-1">
      <span className="cursor-pointer rounded-full p-2 text-slate-500 hover:bg-slate-100 hover:text-slate-900">
        <TbMessage size={22} />
      </span>
    </span>
    <span className="block lg:hidden">
      <MainPopupMenu />
    </span>
  </span>
);

export default MenuHeader;
